/**
 * @fileoverview List detail route configuration
 * Displays detailed view of individual list with all restaurants
 */

// Library imports
import { createFileRoute } from "@tanstack/react-router";

// Page components
import ListDetailsPage from "@/features/dashboard/pages/lists/pages/list-details";

/**
 * Route configuration for the list details page
 * Uses TanStack Router's file-based routing system
 */
export const Route = createFileRoute("/(app)/dashboard/lists/detail/$listId")({
  component: () => {
    // Get list ID from route parameters
    const { listId } = Route.useParams();

    return (
      <main
        role="main"
        aria-label={`List details for ${listId}`}
        className="min-h-screen w-full"
      >
        <ListDetailsPage listId={listId} />
      </main>
    );
  },
  // Add error boundary handling specific to list details
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="font-display text-2xl text-brand">Error Loading List Details</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  )
});